import { Tooltip } from 'teacher-ui-client/components/tooltip'
import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import type { PhosphorIconName } from 'phosphor-icons'

interface Signature {
  Element: Element
  Args: {
    iconStart?: PhosphorIconName
    prefix?: string
    value: number | string
    tooltip: string
  }
}

export const StudentCounts: TOC<Signature> = <template>
  <student-count class="flex items-center gap-x-2" data-test-student-count ...attributes>
    {{#if @iconStart}}
      <PhosphorIcon @icon={{@iconStart}} />
    {{/if}}
    {{#if @prefix}}<span>{{@prefix}}</span>{{/if}}
    <span>{{@value}}</span>
    <Tooltip @text={{@tooltip}} />
  </student-count>
</template>

export default StudentCounts
